import Grid from '@/global/components/ui/Grid'
import { Empresa } from '@/service/api'
import { Divider, Switch } from '@mui/material'
import IconeAjuda from 'global/components/IconeAjuda'
import { useFormContext } from 'react-hook-form'

export default function Digitacao() {
    const { watch, setValue } = useFormContext<Empresa>()
    const valorAtual = watch('esconderLinhasOndeNaoTrabalha') as unknown as
        | string
        | boolean
    const esconder: boolean = valorAtual === 'S' || valorAtual === true

    return (
        <section id="digitacao">
            <Divider
                sx={{
                    mt: 4,
                    mb: 3,
                    userSelect: 'none',
                }}
            >
                Justificativas
            </Divider>
            <Grid container spacing={2}>
                <Grid item xs={12} className="inline-flex items-center">
                    <Switch
                        checked={esconder}
                        onChange={() =>
                            setValue(
                                'esconderLinhasOndeNaoTrabalha',
                                esconder ? 'N' : 'S',
                            )
                        }
                    />
                    <label>Esconder linhas nos dias que não trabalha</label>
                    <IconeAjuda>
                        <p>
                            Quando habilitado, esconde a linha em que o
                            funcionário não deveria trabalhar na tela de
                            digitação (seguindo a tabela de horário e os
                            feriados), mantendo um meio de desbloquear a linha
                            para digitar.
                        </p>
                        <br />
                        <p>
                            Quando desabilitado, mostra todas as linhas para
                            edição direta.
                        </p>
                    </IconeAjuda>
                </Grid>
            </Grid>
        </section>
    )
}
